import { forwardRef } from 'react'
import { Button, Spinner } from './BaseButton.styles'

const BaseButton = forwardRef(({
  children,
  disabled,
  loading,
  margin,
  onClick,
  prefix,
  type = 'button',
  variant = 'primary',
  width,
}, ref) => {
  const isDisabled = disabled || loading

  return (
    <Button
      ref={ref}
      disabled={isDisabled}
      onClick={onClick}
      prefix={prefix}
      style={{ margin, width }}
      type={type}
      variant={variant}
    >
      {loading && <Spinner />}
      {loading ? 'Cargando...' : children}
    </Button>
  )
})

BaseButton.displayName = 'BaseButton'

export default BaseButton
